import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FormTemplateService } from "./../services/form-template.service";
import { ILinkbox } from "./../models/linkbox.model";
import { TextDictionaryService } from "./../services/text-dictionary.service";
import { ITextDictionary } from "./../models/text-dictionary.model";
import textList from "../../assets/data/text-dictionary.json";
import { ZpDataService } from "./../services/zp-data.service";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "./../models/user.model";
import { Subscription } from "rxjs";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { PreviousUrlService } from "../services/previous-url.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";
import { CurrencyConvertService } from "../services/currency-convert.service";
import { ProfessionalFeaturesService } from "../services/professional-features.service";

@Component({
    selector: "dynamic-form",
    templateUrl: "./dynamic-form.component.html",
    styleUrls: ["./dynamic-form.component.scss"],
    host: {
        "(window:click)": "closeFromOutside()",
    },
    standalone: false
})
export class DynamicFormComponent implements OnInit, OnDestroy {
  @ViewChild("myElem") MyProp: ElementRef;
  public formResult: string = "no results yet";
  public open_mainCollapse: [];
  public myFormGroup: UntypedFormGroup;
  public myFormTemplate: ILinkbox;
  public templateName;
  public formType = false;
  public linkType = false;
  public sectionTitle = "";
  public friendlySectionTitle = "";
  public friendlySectionTitleWithClient = "";
  public fts;
  public categoryGrandTotal;
  public testTab: string;
  public collapseStatus = [];
  public showHelp = false;
  public textDictionary: ITextDictionary;
  public myTextDictionary = {};
  public myTextList = textList;
  public myUser: IUser;
  public subscription: Subscription;
  public mySections;
  public assetsAccess = false;
  public debtsAccess = false;
  public dailyLifeAccess = false;
  public wishesAccess = false;
  public dataIsLoaded: boolean = false;
  public delegatesclientName = "";
  public canAdd = false;
  public totalItemCount = 0;
  public categoryCounts;
  public mySharedPlans: {}[];
  public noItems;
  public getSharedPlans: any;
  public statusTooltipMobile = false;
  public statusTooltipMobileSection = [];
  public questionMarkMobile: boolean = false;
  public statusMenu = false;
  public statusExplanations: boolean;
  public statusDropdownAdd2: boolean;
  public myCategoriesBalance;
  public sectionName;
  public previousLink: any;
  public accessRightSection: any;
  public elementToScroll: any;
  public subscription1: Subscription;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public hideBanner: string;
  public companyDetails: {
    userType?: string;
    professionalLicense?: string;
    funded?: boolean;
    hideSponsor?: boolean;
    directInvoice?: boolean;
    email?: string;
    company?: string;
    logo?: string;
    firstName?: string;
    lastName?: string;
    nfz?: any;
  };
  public isNFZ: any;
  public mobileListExpanded: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ftService: FormTemplateService,
    private dictService: TextDictionaryService,
    private ZpDataService: ZpDataService,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private previousUrl: PreviousUrlService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    public currencyService: CurrencyConvertService,
    private professionalFeatures: ProfessionalFeaturesService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.templateName = params.get("templateName");
      this.getCards();
    });
    this.subscription = this.userInfo.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log("myUser - ", this.myUser);
    this.mySharedPlans = await this.ZpDataService.getSharedPlans(this.myUser);
    console.log("mySharedPlans", this.mySharedPlans);
    await this.loadProfessionalDataForNFZ();
    this.statusMenu = false;
    this.getCards();
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true;
    } else {
      this.questionMarkMobile = false;
    }
    
    this.subscription1 =
      this.getInfoAndPassService.accessRightSection.subscribe((data) => {
        this.accessRightSection = data;
        this.elementToScroll = this.accessRightSection.sectionName;
        setTimeout(() => {
          this.scrollFromDashboard(
            document.getElementById(this.elementToScroll)
          );
        }, 500);
      });
  }

  // We're checking if the user is NFZ
  async loadProfessionalDataForNFZ() {
    this.dataIsLoaded = false;
    if (this.myUser && this.myUser.delegate) {
      this.myUser.refCode = this.myUser.delegate.clientRefCode;
      console.log("Dynamic Form - myUser - ", this.myUser);
    }
    await this.professionalFeatures.checkProfessionalCompanyDetails(this.myUser);
    // Access companyDetails from ProfessionalFeaturesService
    this.companyDetails = await this.professionalFeatures.companyDetails;
    console.log("companyDetails - ", this.companyDetails);
    if (this.companyDetails && this.companyDetails.nfz) {
      this.isNFZ = true;
    } else {
      this.isNFZ = false;
    }
    // Set dataIsLoaded to true
    this.dataIsLoaded = true;
  }

  dismissBanner() {
    this.hideBanner = "true";
    localStorage.setItem("session", JSON.stringify(this.hideBanner));
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.ZpDataService.getUser();
    }
  }

  async getCards() {
    this.dataIsLoaded = false;
    await this.getMyUser();
    console.log(this.myUser);
    if (this.myUser && this.myUser.planVersion < 2.0) {
      this.hideBanner = "false";
    } else {
      this.hideBanner = "true";
    }
    if (this.companyDetails && this.isNFZ) {
      this.myFormTemplate = await this.ftService.getFormTemplateAsyncForNFZ(
        this.templateName,
        this.companyDetails.professionalLicense
      );
      console.log("myFormTemplate - ", this.myFormTemplate);
    } else {
      this.myFormTemplate = await this.ftService.getFormTemplateAsync(
        this.templateName
      );
      console.log("myFormTemplate - ", this.myFormTemplate);
    }
    let group = {};
    let counter = 0;
    this.collapseStatus = [];
    this.categoryCounts = (await this.ZpDataService.getAllPlanCategoriesCount(
      this.myUser && this.myUser.sharedPlanUserId
        ? this.myUser && this.myUser.sharedPlanUserId
        : this.myUser && this.myUser.Id
    )) as [];
    //retrieve count for this specific category:
    this.totalItemCount = this.categoryCounts.find(
      (category) => category["categoryName"] == this.myFormTemplate.sectionTitle
    )["count"];
    if (this.totalItemCount > 0 || this.myUser.sharedPlanUserId == true) {
      console.log('this.totalItemCount - ', this.totalItemCount);
      this.noItems = false;
    } else {
      if (
        this.myUser.userType === "professional" &&
        !this.myUser.sharedPlanUserId
      ) {
        this.goto("professional-home-page");
      } else {
        console.log("my user: ", this.myUser);
        // console.log("sharedPlanUserId: ", this.myUser.sharedPlanUserId);

      }
      this.noItems = true;
    }
    switch (this.templateName) {
      default:
        this.sectionTitle = await this.getText(
          this.myFormTemplate.sectionTitle
        );
        this.friendlySectionTitle = this.getFriendlyCategoryTextSection(
          this.sectionTitle,
          false
        );
        this.friendlySectionTitleWithClient = this.getFriendlyCategoryText(
          this.sectionTitle,
          true
        );
        this.mySections = await this.ZpDataService.getPlanCategoryInfo(
          this.myUser.sharedPlanUserId
            ? this.myUser.sharedPlanUserId
            : this.myUser.Id,
          this.sectionTitle
        );
        console.log("mySections - ", this.mySections);
        // inverse mysections grandtotal from negative to positive  for display
        this.mySections.forEach((section) => {
          // if section has grandtotal and is negative then inverse it to positive  for display
          if (section["grandTotal"] && section["grandTotal"] < 0) {
            section["grandTotal"] = section["grandTotal"] * -1;
          }
        });
        if (!this.mySections) {
          console.log("Error: mySections null");
        }
        this.myFormTemplate.cards.forEach(async (card) => {
          this.collapseStatus[counter] = false;
          card.cardId = "object_" + counter++;
          let thisCard = this.mySections.find(
            (section) => section["sectionName"] == card.title
          );
          try {
            card.itemCount = thisCard["itemCount"];
          } catch {
            card.itemCount = 0;
          }
          if (card.itemCount > 0) {
            // log out item count
            card["items"] = thisCard["items"];
            card["grandTotal"] = thisCard["grandTotal"];
            if (card["grandTotal"] < 0) {
              card["grandTotal"] = card["grandTotal"] * -1;
            }
          } else {
            card["items"] = [];
            card["grandTotal"] = 0;
            if (card["grandTotal"] < 0) {
              card["grandTotal"] = card["grandTotal"] * -1;
            }
          }
        });
        break;
    }
    this.sectionTitle = await this.getText(this.myFormTemplate.sectionTitle);
    this.dataIsLoaded = true;
    //this.sectionTitle is really categoryTitle like "my assets"
    this.canAdd = await this.ZpDataService.getCanEdit(
      this.myUser,
      this.sectionTitle
    );
  }

  onSubmit() {
    this.formResult = this.myFormGroup.value;
  }

  goto(url: string) {
    this.router.navigate(["/" + url]);
  }

  add(url: string, card) {
    let addUrl = url;
    if (card && card.items.length > 0) {
      if (card && card.ownership == true) {
        addUrl = addUrl.replace(/\-edit$/, "") + "_joint-owners";
      } else {
        addUrl = addUrl.replace(/\-edit$/, "") + "_1";
      }
    } else {
      console.log('card - ', card);
      console.log('isNFZ - ', this.isNFZ);
      console.log('addUrl - ', addUrl);
      if (this.isNFZ) {
        addUrl = addUrl.replace(/\-edit$/, "") + "-intro-isNFZ";
      } else {
        addUrl = addUrl.replace(/\-edit$/, "") + "-intro";
      }
    }
    this.router.navigate(["/" + addUrl]);
  }

  scroll(id, index?) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView();
    if (this.collapseStatus.length > index) {
      this.collapseStatus[index] = true;
    }
  }

  scrollFromDashboard(id) {
    if ((this.previousLink = "/my-dashboard")) {
      if (id) {
        id.scrollIntoView();
      }
    }
  }

  openMenu($event) {
    $event.stopPropagation();
    this.statusMenu = !this.statusMenu;
  }

  closeFromOutside() {
    this.statusMenu = false;
    this.statusExplanations = false;
    this.statusDropdownAdd2 = false;
  }

  edit(id, editurl) {
    this.router.navigate(["/dynamicedit/" + editurl + "/" + id]);
  }
  view(id, viewurl) {
    this.router.navigate(["/dynamicview/" + viewurl + "/" + id]);
  }

  toggleExplanations($event) {
    $event.stopPropagation();
    this.statusExplanations = !this.statusExplanations;
    if ((this.statusDropdownAdd2 = true)) {
      this.statusDropdownAdd2 = false;
    }
  }

  toggleDropdown($event) {
    $event.stopPropagation();
    this.statusDropdownAdd2 = !this.statusDropdownAdd2;
    if ((this.statusExplanations = true)) {
      this.statusExplanations = false;
    }
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  getFriendlyCategoryText(unfriendly: string, includeClient: boolean) {
    let retVal = "";
    if (unfriendly.toLowerCase().includes("asset")) {
      retVal = "Assets";
    }
    if (unfriendly.toLowerCase().includes("debt")) {
      retVal = "Debts";
    }
    if (unfriendly.toLowerCase().includes("daily")) {
      retVal = "Daily Life";
    }
    if (unfriendly.toLowerCase().includes("digital")) {
      retVal = "Digital Life";
    }
    if (unfriendly.toLowerCase().includes("wish")) {
      retVal = "Wishes";
    }
    if (this.myUser.delegate && includeClient) {
      retVal =
        retVal +
        " - " +
        this.myUser.delegate.clientFirstName +
        " " +
        this.myUser.delegate.clientLastName;
    }
    return retVal;
  }

  getFriendlyCategoryTextSection(unfriendly: string, includeClient: boolean) {
    let retVal = "";
    if (unfriendly.toLowerCase().includes("asset")) {
      retVal = "Asset";
    }
    if (unfriendly.toLowerCase().includes("debt")) {
      retVal = "Debt";
    }
    if (unfriendly.toLowerCase().includes("digital")) {
      retVal = "Digital Life";
    }
    if (unfriendly.toLowerCase().includes("wish")) {
      retVal = "Wishe";
    }
    if (this.myUser.delegate && includeClient) {
      retVal =
        retVal +
        " - " +
        this.myUser.delegate.clientFirstName +
        " " +
        this.myUser.delegate.clientLastName;
    }
    return retVal;
  }

  ngOnDestroy() {
    this.statusMenu = false;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
